import ApiService from '@/services/ApiService';
import Store from '@/store';
import i18n from '@/i18n';

const LOG_KEY = 'log';

const LogService = {

    /**
     * Add log line
     */
    info(data) {
        const venue = Store.getters?.tenant?.venue;
        if(!venue) return false;

        const user = Store.getters?.user
        const date = moment().format('YYYY-MM-DD HH:mm:ss')
        const text = i18n.t(`log.${data.type}`, data)

        data = {
            ...data,
            userId: user?.id || null,
            date
        }

        const logLine = `${date}${user ? (' ' + user.name + ':') : ''} ${text}|${JSON.stringify(data)}`;

        let log = this.getLog();
        log = log ? (log + '\n' + logLine) : logLine;

        if (!Store.getters.isOnline) {
            this.setLog(log);
            return true;
        }

        ApiService.post('/log', { log }).then(response => {
            this.removeLog(null);
        }).catch(error => {
            this.setLog(log);
        })

        return true;
    },

    /**
     * Get Log
     */
    getLog() {
        return AppStorage.local().getItem(LOG_KEY);
    },

    /**
     * Set Log
     */
    setLog(log) {
        AppStorage.local().setItem(LOG_KEY, log);
    },

    /**
     * Remove Log
     */
    removeLog() {
        AppStorage.local().deleteItem(LOG_KEY);
    },

    /**
     * Get Timezone
     */
    getTimezone() {
        const timezone = Store.getters?.tenant?.venue?.timezone
        if(timezone) {
            return timezone
        }

        switch (locale) {
            case 'me':
                return 'Europe/Podgorica';
            case 'sr':
                return 'Europe/Belgrade';
            case 'ba':
                return 'Europe/Sarajevo';
            default:
                return 'UTC';
        }
    },
};

export default LogService;

export { LogService };
